import { switchLanguage } from "actions/Setting";
import React from "react";
import Autosuggest from "react-autosuggest";
import { connect } from "react-redux";
import {
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import swal from "sweetalert2";
import IntlMessages from "util/IntlMessages";
import { fetchData, postData } from "../../../auth";
// import useStyles from "../components/material-ui-styles";
import { Button, Input } from "reactstrap";
class legalDictionary extends React.Component {
  constructor(props) {
    super(props);
    let lang = props.match.params.lang;
    let locale = props.locale.locale;

    if (lang !== undefined) {
      if (locale !== lang) {
        if (lang == "en")
          props.switchLanguage({
            languageId: "english",
            locale: "en",
            name: "English",
            icon: "us",
          });
        else
          props.switchLanguage({
            languageId: "saudi-arabia",
            locale: "ar",
            name: "العربية",
            icon: "sa",
          });
      }
    }
    this.state = {
      editedOBJ: [],
      terms: [],
      role_id: null,
      lang_id: null,
      arabicTerm: "",
      englishTerm: "",
      columnData: [],
      adding: false,
      Gstate: "",
      editedId: null,
      editing: false,
      isSendingSuggest: false,
      modal: false,
      TERMS: [],
      termsCount: 0,
      allData: [],
      data: [],
      allterms: [],
      value: "",
      suggestions: [],
      arabicTermValue: "",
      englishTermValue: "",
      arabicTermSuggestions: [],
      englishTermSuggestions: [],
    };
    //this.onAdd = this.onAdd.bind(this);
    this.getTerms = this.getTerms.bind(this);
    this.addTerms = this.addTerms.bind(this);
    // this.onDelete = this.onDelete.bind(this);
    // this.onEdit = this.onEdit.bind(this);
    // this.onSelected = this.onSelected.bind(this);
    // this.handleCancel = this.handleCancel.bind(this);
    // this.editTerms = this.editTerms.bind(this);
  }

  async getTerms() {
    let res = await fetchData("/lawDictionary/v1/get");

    return res ? res.result : [];
  }

  async addTerms(e) {
    e.preventDefault();
    let data = {
      arabicTerm: "",
      englishTerm: "",
      theSubject: "",
      notes: this.state.notes,
    };
    let res = await postData("/lawDictionary/v1/add", data);

    if (res) {
      swal.fire({
        title: this.props.locale.locale == "ar" ? "شكراً لك" : "Thank You",
        confirmButtonText: this.props.locale.locale == "ar" ? "حسناً" : "Ok",
      });
    }
    this.setState({
      notes: "",
    });
    //}
    // });
    //  }
  }
  handleChatInputPress = (e) => {
    if (e.key === "Enter") {
      this.addTerms(e);
      this.setState({
        modal: !this.state.modal,
        isSendingSuggest: !this.state.isSendingSuggest,
      });
    }
  };

  toggle = () => {
    this.setState({
      modal: !this.state.modal,
      isSendingSuggest: !this.state.isSendingSuggest,
    });
  };

  escapeRegexCharacters(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  getSuggestions(value) {
    const escapedValue = this.escapeRegexCharacters(value.trim());
    const regex = new RegExp("^" + escapedValue, "i");
    return this.state.terms.filter(
      (term) => regex.test(term.arabicTerm) || regex.test(term.englishTerm)
    );
  }

  getSuggestionArabicTerm(suggestion) {
    return suggestion.arabicTerm;
  }

  getSuggestionEnglishTerm(suggestion) {
    return suggestion.englishTerm;
  }

  renderSuggestionArabicTerm(suggestion) {
    return <span>{suggestion.arabicTerm}</span>;
  }
  renderSuggestionEnglishTerm(suggestion) {
    return <span>{suggestion.englishTerm}</span>;
  }

  onArabicTermChange = (event, { newValue }) => {
    if (newValue.length === 0) {
      this.setState({
        arabicTermValue: "",
        englishTermValue: "",
      });
    } else {
      this.setState({
        arabicTermValue: newValue,
      });
    }
  };

  onEnglishTermChange = (event, { newValue }) => {
    if (newValue.length === 0) {
      this.setState({
        arabicTermValue: "",
        englishTermValue: "",
      });
    } else {
      this.setState({
        englishTermValue: newValue,
      });
    }
  };

  onArabicTermSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      arabicTermSuggestions: this.getSuggestions(value),
    });
  };

  onArabicTermSuggestionsClearRequested = () => {
    this.setState({
      arabicTermSuggestions: [],
    });
  };

  onArabicTermSuggestionSelected = (event, { suggestion }) => {
    this.setState({
      englishTermValue: suggestion.englishTerm,
    });
  };

  onEnglishTermSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      englishTermSuggestions: this.getSuggestions(value),
    });
  };

  onEnglishTermSuggestionsClearRequested = () => {
    this.setState({
      englishTermSuggestions: [],
    });
  };

  onEnglishTermSuggestionSelected = (event, { suggestion }) => {
    this.setState({
      arabicTermValue: suggestion.arabicTerm,
    });
  };

  renderInputComponent = (inputProps) => (
    <div className="inputContainer">
      <textarea {...inputProps} />
    </div>
  );
  renderEnInputComponent = (inputProps) => (
    <div className="inputContainer">
      <textarea {...inputProps} />
    </div>
  );

  async componentDidMount() {
    let role_id = await localStorage.getItem("ROLE_ID");
    let TERMS = await this.getTerms();
    let termsCount = TERMS.length;

    this.setState({
      terms: TERMS,
      TERMS: TERMS,
      // allterms: TERMS,
      // columnData: columnData,
      // allData: TERMS,
      // data: TERMS,
      termsCount,
    });
  }
  handleRest = () => {
    this.setState({
      arabicTermValue: "",
      englishTermValue: "",
      arabicTermSuggestions: [],
      englishTermSuggestions: [],
    });
  };
  render() {
    const {
      arabicTermValue,
      arabicTermSuggestions,
      englishTermValue,
      englishTermSuggestions,
    } = this.state;
    const arabicTermInputProps = {
      multiline: true,
      placeholder: "اكتب هنا",
      value: arabicTermValue,
      type: "search",
      onChange: this.onArabicTermChange,
    };
    const englishTermInputProps = {
      placeholder: "Type here",
      value: englishTermValue,
      type: "textarea",
      onChange: this.onEnglishTermChange,
    };

    return (
      <Container className="paddingnull mt-4 containerTrans">
        <div className="col-12 base-training-div ">
          <div className="col-12 d-flex autoTranslate">
            <div className="col-12 col-sm-6 engTrans">
              <div className="spanTitleAr">
                <p> عربي</p>
              </div>
              <Autosuggest
                suggestions={arabicTermSuggestions}
                onSuggestionsFetchRequested={
                  this.onArabicTermSuggestionsFetchRequested
                }
                onSuggestionsClearRequested={
                  this.onArabicTermSuggestionsClearRequested
                }
                onSuggestionSelected={this.onArabicTermSuggestionSelected}
                getSuggestionValue={this.getSuggestionArabicTerm}
                renderSuggestion={this.renderSuggestionArabicTerm}
                inputProps={arabicTermInputProps}
                renderInputComponent={this.renderInputComponent}
              />
            </div>
            <div className="icon-Translate" onClick={this.handleRest}>
              <i class="far fa-exchange"></i>
            </div>
            <div className="col-12 col-sm-6 engTrans enText">
              <div className="spanTitleEn">
                <p> English</p>
              </div>
              <Autosuggest
                suggestions={englishTermSuggestions}
                onSuggestionsFetchRequested={
                  this.onEnglishTermSuggestionsFetchRequested
                }
                onSuggestionsClearRequested={
                  this.onEnglishTermSuggestionsClearRequested
                }
                onSuggestionSelected={this.onEnglishTermSuggestionSelected}
                getSuggestionValue={this.getSuggestionEnglishTerm}
                renderSuggestion={this.renderSuggestionEnglishTerm}
                inputProps={englishTermInputProps}
                renderInputComponent={this.renderEnInputComponent}
              />
            </div>
          </div>

          {this.state.modal == true && (
            <Modal
              isOpen={this.state.modal}
              toggle={this.toggle}
              style={{ marginTop: "300px", width: "700px" }}
              className="modal-msg"
            >
              <ModalHeader toggle={this.toggle} className="chat-se">
                <span>
                  <span>
                    {" "}
                    <IntlMessages id="suggest.Term" /> &nbsp;&nbsp;
                  </span>
                </span>
              </ModalHeader>
              <ModalBody className="scrol-msg">
                <span>
                  {this.state.isSendingSuggest && (
                    <span>
                      <Input
                        className=" suggestTerm"
                        type="text"
                        value={this.state.notes}
                        onKeyPress={(e) => this.handleChatInputPress(e)}
                        onChange={(e) =>
                          this.setState({ notes: e.target.value })
                        }
                      />
                      <Button
                        size="small"
                        className="mb-2 "
                        onClick={(e) => {
                          this.addTerms(e);
                          this.setState({
                            isSendingSuggest: !this.state.isSendingSuggest,
                            modal: !this.state.modal,
                          });
                        }}
                      >
                        <IntlMessages id="submit.suggest" />
                      </Button>
                    </span>
                  )}
                </span>{" "}
              </ModalBody>
              <ModalFooter className="border-footer"></ModalFooter>
            </Modal>
          )}
        </div>
      </Container>
    );
  }
}

const mapStateToProps = ({ settings }) => {
  const { locale } = settings;
  return { locale };
};

export default connect(mapStateToProps, { switchLanguage })(legalDictionary);
